import React, { useState } from 'react';
import useScreenBreakpoint from 'src/hooks/useMediaQuery';
import Card from 'src/components/Card';
import { CardContent, Toolbar, Typography } from '@material-ui/core';
import Button from 'src/components/Button';
import { createUseStyles } from 'src/theming';
import styles from './List.styles';
import DeliveryOrderTable from './components/DeliveryOrderTable';
import SearchView from './components/SearchView';
import { DeliveryOrderCriteria } from 'src/interfaces/api/DeliveryOrder';

const useStyles = createUseStyles(styles);

const List = ({ history }) => {
  const screenBreakPoint = useScreenBreakpoint();
  const classes = useStyles();

  const [searchCriteria, setSearchCriteria] = useState<DeliveryOrderCriteria>({
    status: undefined,
  });

  const handleAddInterventionOrder = () => {
    history.push('/dashboard/delivery-orders/new');
  };

  return (
    <div id='appView' className='div-entity'>
      <Card className={classes.root}>
        <Toolbar>
          <Typography variant='h6' className={classes.title} component='div'>
            Bons de livraison
          </Typography>

          <Button variant='contained' color='primary' onClick={handleAddInterventionOrder}>
            {screenBreakPoint === 'xs' ? '+' : '+ Nouveau'}
          </Button>
        </Toolbar>

        <CardContent>
          <SearchView searchCriteria={searchCriteria} onCriteriaChange={(criteria) => setSearchCriteria(criteria)} />
          <DeliveryOrderTable searchCriteria={searchCriteria} />
        </CardContent>
      </Card>
    </div>
  );
};

export default List;
